import { useEffect, useState } from 'react';

import { LoadingState } from '../LoadingState';
import { LatestReviewSummaryPopover } from './LatestReviewSummaryPopover';
import { getLatestReviews } from './util/getLatestReviews';

export const LatestReviewSummaryPopoverMapper = ({
  patientInfo,
  patientDetails,
}) => {
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const revs = await getLatestReviews(
          patientInfo.entityid,
          patientInfo.admissionid
        );
        setReviews(revs);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [setReviews, patientInfo.entityid, patientInfo.admissionid]);

  const handleQuickLinkClick = (event) => {
    event.preventDefault();
    patientDetails(patientInfo);
  };

  if (isLoading)
    return (
      <LoadingState
        title='Latest Review Summary'
        buttonText='Go to Reviews'
        onClick={handleQuickLinkClick}
      />
    );

  return (
    <>
      {reviews.latestURReview?.data && (
        <LatestReviewSummaryPopover
          patientInfo={patientInfo}
          patientDetails={patientDetails}
          review={reviews.latestURReview.data}
          title={reviews.latestURReview.title}
          withStatusIndicator
        />
      )}
      {reviews.latestPAReview?.data && (
        <LatestReviewSummaryPopover
          patientInfo={patientInfo}
          patientDetails={patientDetails}
          review={reviews.latestPAReview.data}
          title={reviews.latestPAReview.title}
        />
      )}
      {reviews.latestPayerReview?.data && (
        <LatestReviewSummaryPopover
          patientInfo={patientInfo}
          patientDetails={patientDetails}
          review={reviews.latestPayerReview.data}
          title={reviews.latestPayerReview.title}
        />
      )}
    </>
  );
};
